<template>
  <div class="comp-fh-table">
    <template v-if="curCols?.length">
      <div class="fh-table" :ref="$attrs.ref || 'fhTableRefWrap'">
        <t-table ref="fhTableRef" :bordered="props.bordered" v-bind="$attrs" :columns="columns" :size="props.size" :on-column-resize-change="columnResize" cell-empty-content="-">
          <template #empty>
            <div class="fh-table-spin" v-if="!$attrs.loading">
              <jw-empty></jw-empty>
            </div>
            <div v-else>
              <jw-spin :style="{ width: '100%' }"></jw-spin>
            </div>
          </template>
          <template v-for="(slot, slotName) in $slots" #[slotName]="slotProps" :key="slotName">
            <slot :name="slotName" v-bind="slotProps" />
          </template>
          <template #loading>
            <jw-spin :style="{ width: '100%' }"></jw-spin>
          </template>
          <!-- <div :style="{ padding: '0 32px', marginTop: '46px', overflow: 'hidden' }" v-if="$attrs.loading">
            <ly-skeleton fromType="mainTable" :lineHeight="26" :row="3" :tableColumns="showCol?.filter((e) => !['row-select', 'operations'].includes(e.colKey))?.map((v) => v.width)"></ly-skeleton>
          </div> -->
        </t-table>
      </div>
      <fh-col-select :key="uuid" :cols="cols" :isColsAll="isColsAll" :defcols="stateDefCol || {}" ref="tableColSelect" @cb="getCols" @cbIsGroup="getGroupCols"><span></span></fh-col-select>
    </template>
    <!-- <div class="fh-table-loading" v-else>
      <jw-spin :loading="curCols?.length == 0" :style="{ width: '100%' }"></jw-spin>
    </div> -->
  </div>
</template>

<script setup>
import md5 from 'js-md5';
import { ref, computed, watchEffect, watch, useAttrs } from 'vue';
import CONFIG from '@/config/config';
const attrs = useAttrs();

console.log('父组件属性', attrs);
const fhTableRef = ref();
const uuid = computed(() => attrs.uuid);
const storage = {
  // localStorage
  setItem(key, value) {
    if (key && value) {
      const v = JSON.stringify(value);
      localStorage.setItem(key, v);
      // console.log(29, value);
      return value;
    }
    return value;
  },
  getItem(key) {
    let v = localStorage.getItem(key);
    if (v !== 'null' && v !== undefined) {
      v = JSON.parse(v);
    }
    return v;
  },
  removeItem(key) {
    return localStorage.removeItem(key);
  }
};

const props = defineProps({
  columns: {
    type: Array,
    default: () => [],
    validator(v) {
      if (v?.length === 0) {
        return true;
      }
      const colKey = v.reduce((prev, cur) => {
        const f = prev.includes(cur.colKey);
        if (!f) {
          prev.push(cur.colKey);
        }
        return prev;
      }, []);
      // The v must match one of these strings
      return colKey.length === v.length;
    }
  },
  bordered: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'small'
  },
  viewId: {
    type: [String],
    default: ''
  },
  isGroupTop: {
    type: [String],
    default: ''
  },
  refGroupKey: {
    type: [String],
    default: ''
  },
  //组件调用来源 35 子表单
  fromPage: {
    type: String,
    default: ''
  }
});

const emits = defineEmits(['cbGroup']);

const refGroupKey = computed(() => props.refGroupKey);
const curCols = computed(() => props.columns);

const isColsAll = ref('');

// 获取当前显示的列
let c = curCols.value.filter((ele) => ele.colShow !== false);
// 要传给 列选择的所有列
const cols = ref([]);
cols.value = curCols.value.map((el) => ({ ...el }));
console.log(118, cols.value);
// 要存储到本地数据的列数据
// 生成唯一key
let uniqueKey = curCols.value.map((el) => el.colKey).join('') + curCols.value.length;
// let uniqueKey = curCols.value.map((el) => el.colKey.substr(0, 2)).join('') + curCols.value.length;
// 保存默认列和实际列
const tableKey = ref(`${CONFIG.prefix}TABLE_COLS_${props.viewId || uuid.value}_${md5(uniqueKey)}`);
// 2022-12-23 update 默认列

let defCols = curCols.value.reduce((prev, cur) => {
  const tmp = {};
  // 支持子表单拖拽
  if (cur.children?.length) {
    cur.children.forEach((item) => {
      if (item?.width) {
        prev[item.colKey] = { width: item.width };
      }
    });
  } else {
    if (cur.width) tmp.width = cur.width;
    if (cur.fixed) tmp.fixed = cur.fixed;
    if (cur.colShow === false) tmp.colShow = cur.colShow;
    prev[cur.colKey] = tmp;
  }
  return prev;
}, {});

let defColsSort = curCols.value.map((el) => el.colKey);

// 默认列的值
let kf = storage.getItem(tableKey.value) || { k: defCols, sort: defColsSort };
let kfDef = { k: defCols, sort: defColsSort };
// 设置的宽高
// let state = useStorage(key, curCols.value);
const state = ref(kf);
// 默认的顺序和宽高
const stateDefCol = ref(kfDef);
if (curCols.value.length) {
  state.value = storage.setItem(tableKey.value, kf);
  stateDefCol.value = storage.setItem(`${tableKey.value}_DEFAULT`, kfDef);
}
// 2022-12-23 update 默认列
// 要显示的列
const showCol = ref(c);
watch(
  () => props.columns,
  () => {
    if (props.fromPage === '35') {
      showCol.value = curCols.value.filter((ele) => ele.colShow !== false);
    }
  },
  { deep: true }
);
if (state.value) {
  const stateCols = state.value.sort.map((el) => {
    let tmp = {};
    const f = curCols.value.find((ele) => ele.colKey === el);
    if (f) {
      tmp = Object.assign({}, { ...f }, { ...state.value?.k[el] });
    }
    return tmp;
  });
  showCol.value = stateCols.filter((el) => el.colShow !== false);
  cols.value = stateCols;
}

watchEffect(() => {
  // 获取当前显示的列
  c = curCols.value.filter((ele) => ele.colShow !== false);
  // 要传给 列选择的所有列

  cols.value = curCols.value.map((el) => ({ ...el }));

  // 要存储到本地数据的列数据
  // 生成唯一key
  // uniqueKey = curCols.value.map((el) => el.colKey.substr(0, 2)).join('') + curCols.value.length;
  uniqueKey = curCols.value.map((el) => el.colKey).join('') + curCols.value.length;
  // 保存默认列和实际列
  tableKey.value = `${CONFIG.prefix}TABLE_COLS_${props.viewId || uuid.value}_${md5(uniqueKey)}`;

  // 2022-12-23 update 默认列

  defCols = curCols.value.reduce((prev, cur) => {
    const tmp = {};
    if (cur.children?.length) {
      cur.children.forEach((item) => {
        if (item?.width) {
          prev[item.colKey] = { width: item.width };
        }
      });
    } else {
      if (cur.width) tmp.width = cur.width;
      if (cur.fixed) tmp.fixed = cur.fixed;
      if (cur.colShow === false) tmp.colShow = cur.colShow;
      prev[cur.colKey] = tmp;
    }
    return prev;
  }, {});

  defColsSort = curCols.value
    .sort((a, b) => {
      // 定义优先级函数
      const getPriority = (item) => {
        if (item.fixed === 'left') return 1;
        if (item.fixed === 'right') return 3;
        return 2; // 其他情况
      };
      const aPriority = getPriority(a);
      const bPriority = getPriority(b);
      // 根据优先级排序
      return aPriority - bPriority;
    })
    .map((el) => el.colKey);

  // 默认列的值
  kf = storage.getItem(tableKey.value) || { k: defCols, sort: defColsSort };
  kfDef = { k: defCols, sort: defColsSort };
  // 设置的宽高
  // state = useStorage(tableKey.value, curCols.value);

  if (curCols.value.length) {
    state.value = storage.setItem(tableKey.value, kf);
    stateDefCol.value = storage.setItem(`${tableKey.value}_DEFAULT`, kfDef);
  }

  // 2022-12-23 update 默认列
  // 要显示的列
  if (state.value) {
    const stateCols = state.value.sort.map((el) => {
      let tmp = {};
      const f = curCols.value.find((ele) => ele.colKey === el);

      if (f?.children?.length) {
        f.children.forEach((child) => {
          const isWidth = state.value?.k?.[child.colKey]?.width;
          child.width = isWidth ? isWidth : child?.width;
        });
        // 如何根据else中的方式改写，返回这个
        tmp = Object.assign({}, { ...f });
      } else {
        tmp = Object.assign({}, { ...f }, { ...state.value?.k[el] });
        if (!state.value?.k[el]?.fixed && tmp?.fixed) {
          // delete tmp.fixed;
        }
      }

      return tmp;
    });
    // showCol.value = stateCols.filter((el) => el.colShow !== false);
    const formatSortShowCol = [];
    stateCols
      .filter((el) => el.colShow !== false)
      .map((scv) => {
        if (attrs?.sortOrder?.colKey && attrs?.sortOrder?.colKey == scv.colKey) {
          scv.sortable['sortOrder'] = attrs?.sortOrder?.sortOrder;
        } else {
          if (scv.sortable?.sortOrder) delete scv.sortable?.sortOrder;
        }
        formatSortShowCol.push(scv);
      });
    showCol.value = formatSortShowCol;
    cols.value = stateCols;
  }
});
// 这是列选择相关代码 S
const tableColSelect = ref(null);
// const uuid = ref();
const openColSelect = (v = null) => {
  if (v) {
    isColsAll.value = v;
  }
  // uuid.value = uuid;
  tableColSelect.value?.openDialog();
};

const getGroupCols = (v) => {
  emits('cbGroup', v);
};

// 获取列选择的值
const getCols = (v) => {
  let c = [...v];
  // 要移动的对象的条件

  const fixColumnsKeys = [];
  c.forEach((cItem) => {
    if (['custom-operations'].includes(cItem.colKey)) {
      fixColumnsKeys.push(cItem.colKey);
    }
  });

  // 找到符合条件的对象的索引
  const firstTwoKeys = c.slice(0, fixColumnsKeys.length)?.map((sItem) => sItem.colKey); // 前两项的key
  const missingKeys = fixColumnsKeys.filter((key) => !firstTwoKeys.includes(key));

  if (missingKeys.length > 0) {
    const itemsToMove = c.filter((item) => fixColumnsKeys.includes(item.colKey)); //固定的前两项目
    const remainingItems = c.filter((item) => !fixColumnsKeys.includes(item.colKey)); // 剩余的其他项
    c = [...itemsToMove, ...remainingItems];
  }

  // const condition = 'row-select'; // 计算状态 行选择
  // const indexToMove = c.findIndex((obj) => obj.colKey === condition);
  // // 如果找到符合条件的对象并且不在第一位
  // if (indexToMove !== -1 && indexToMove !== 0) {
  //   // 移除该对象并插入到第一位置
  //   c.unshift(c.splice(indexToMove, 1)[0]);
  // }

  const cf = c.filter((el) => el.colShow !== false);
  console.log(220, v, cf);
  const kfc = {
    k: c.reduce((prev, cur) => {
      const tmp = {};
      if (cur.children?.length) {
        cur.children.forEach((item) => {
          if (item?.width) {
            prev[item.colKey] = { width: item.width };
          }
        });
      } else {
        if (cur.width) tmp.width = cur.width;
        if (cur.fixed) tmp.fixed = cur.fixed;
        if (cur.colShow === false) tmp.colShow = cur.colShow;
      }
      prev[cur.colKey] = tmp;
      console.log(2099, prev[cur.colKey]);
      return prev;
    }, {}),
    sort: c.map((el) => el.colKey)
  };
  state.value = kfc;
  state.value = storage.setItem(tableKey.value, kfc);
  showCol.value = cf.map((el) => ({ ...el }));

  console.log('showCol.value', showCol.value, kfc);
};
// 这是列选择相关代码 E

// 调整列宽
let time = null;
const columnResize = (width) => {
  console.log(229, tableKey.value, width);
  const s = storage.getItem(tableKey.value);
  console.log(229, s);
  // const colKey = tableKey.value;
  if (s) {
    if (time) {
      clearTimeout(time);
      time = null;
    }
    time = setTimeout(() => {
      for (const key in width.columnsWidth) {
        if (width.columnsWidth.hasOwnProperty.call(width.columnsWidth, key) && s.k.hasOwnProperty.call(s.k, key)) {
          if (!(props.isGroupTop == 'top' && key == 'row-select')) {
            s.k[key].width = width?.columnsWidth[key];
          }
        }
      }
      state.value = storage.setItem(tableKey.value, s);
    }, 300);
  }
};

// 导出子组件
defineExpose({
  tableColSelect,
  fhTableRef,
  refGroupKey,
  getCols,
  openColSelect // 列选择的ref
});
</script>
<style scoped lang="less">
@import './fh-table.less';
</style>
